import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  errors: null,
  data: {
    callTimestamp: null
  }
};

export const slice = createSlice({
  name: 'initiate',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data.callTimestamp = payload;
      state.errors = initialState.errors;
    },
    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = initialState.data;
      state.errors = payload;
    }
  }
});

export const {
  setInitialState,
  setIsLoading,
  setSuccess,
  setError
} = slice.actions;

export const selectInitiateSlice = (state) => state[slice.name];
export const selectInitiateData = (state) => state[slice.name].data;
export const selectIsLoading = (state) => selectInitiateSlice(state).isLoading;
export const selectCallTimestamp = (state) =>
  selectInitiateData(state).callTimestamp;
export const selectErrors = (state) => selectInitiateSlice(state).errors;

export default slice.reducer;
